module.exports = {
          srcSet: __webpack_public_path__ + "img/b9359a6-1232.jpg"+" 1232w",
          images:[ {path: __webpack_public_path__ + "img/b9359a6-1232.jpg",width: 1232,height: 924}],
          src: __webpack_public_path__ + "img/b9359a6-1232.jpg",
          toString:function(){return __webpack_public_path__ + "img/b9359a6-1232.jpg"},
          
          width: 1232,
          height: 924
        }